module.exports = __webpack_public_path__ + "img/English-07.e4323b69.jpg";